import { Injectable } from '@angular/core';
import { OwlDateTimeIntl } from '@danielmoncada/angular-datetime-picker';

@Injectable()
export class ItalianOwlDateTimeIntl extends OwlDateTimeIntl {
  /** etichette dei pulsanti */
  override cancelBtnLabel = 'Annulla';
  override setBtnLabel = 'Imposta';
}
